"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.instagramContract = exports.publicInstagramContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.publicInstagramContract = c.router({
    getLatestPosts: {
        method: 'GET',
        path: '/latest-posts',
        query: zod_1.z.object({
            limit: zod_1.z.coerce.number().int().positive().optional(),
        }),
        responses: {
            200: models_1.ZInstagramLatestPostsResponse,
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
            500: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
        summary: 'Get the latest Instagram posts from Daymade',
    },
}, {
    pathPrefix: '/public',
});
exports.instagramContract = c.router({
    public: exports.publicInstagramContract,
}, {
    pathPrefix: '/instagram',
    strictStatusCodes: true,
});
__exportStar(require("./models"), exports);
//# sourceMappingURL=index.js.map